module.exports = __webpack_public_path__ + "img/icon-live-tv-folder.7603c133.svg";